import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18Like2 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M11.276 3.107a4.14 4.14 0 0 0-2.193.782l-.168.129-.173-.133a4.144 4.144 0 0 0-5.398.472 4.69 4.69 0 0 0-.213 6.276c1.519 1.884 4.506 4.414 5.668 4.545l.119.013.117-.018c.527-.08 1.421-.63 2.382-1.38l.448-.36q.225-.187.45-.382l.447-.399.22-.204.428-.412c.49-.483.94-.97 1.3-1.418 1.535-1.822 1.444-4.53-.222-6.259A4.14 4.14 0 0 0 11.515 3.1zm.239 1.793a2.34 2.34 0 0 1 1.679.71 2.89 2.89 0 0 1 .127 3.864c-.598.742-1.592 1.72-2.583 2.552l-.175.145-.369.295-.345.261-.313.225-.274.183a4 4 0 0 1-.32.189l-.062.028-.012-.004c-.207-.09-.55-.32-.96-.636l-.366-.29-.39-.326a27 27 0 0 1-.406-.352l-.41-.371-.408-.384-.394-.387a15 15 0 0 1-1.013-1.113 2.895 2.895 0 0 1 .117-3.881 2.34 2.34 0 0 1 3.356.002l.872.872.925-.828c.485-.498 1.091-.754 1.724-.754"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Like2$1 = Svg18Like2;

export { Svg18Like2$1 as default };
